<template>
    <div class="error-page">
      <h1>Error {{ error.value?.statusCode || 500 }}</h1>
      <p>{{ error.value?.message || "An unexpected error occurred." }}</p>
      <NuxtLink to="/">Go back to the homepage</NuxtLink>
    </div>
  </template>
  
  <script setup>
  const dataAll = useDataAll();
  const { $methods } = useNuxtApp()

  // Access the error details
  const error = useError();

  if ($methods?.logError) {
    $methods.logError(error.value.message + "\n\rURL:"+error.value.url+"\n\rSTACK:"+error.value.stack)

  } else {
     console.error("logError method does not exist or $methods is not available");
  }
  
  
  </script>
  


  <style scoped>
  .error-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    text-align: center;
    color: #333;
  }
  h1 {
    font-size: 2.5em;
    color: #e74c3c;
  }
  p {
    font-size: 1.2em;
  }
  </style>
  